import "./style/main.css";
import "uno.css";
import { createApp } from "vue";
import { createPinia } from "pinia";
import { ref } from "vue";
import { ConfigProvider } from "ant-design-vue";
import App from "./App.vue";
import router from "./router";
import "virtual:svg-icons-register";
import i18n from "./locales";
import directives from "./plugins/directives";
import { set } from "lodash-es";
import { restoreSession } from "./utils";
import { initPaddle } from "@/plugins/paddle";
import { useUserStore } from "@/stores/user";
import { globalEventHandler } from "@/services/globalEventHandler";

// 检查是否为客户端环境
const isClient = typeof window !== "undefined";

// 设置Ant Design主题
if (isClient) {
  ConfigProvider.config({
    theme: {
      primaryColor: "#1890ff", // 蓝色主色调
    },
  });
}

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

notification.config({ top: "68px", duration: 3 });
const loading = ref(true);
// 全局loading状态
app.provide("isLoading", loading.value);

if (isClient) {
  // 初始化 Paddle
  if ("requestIdleCallback" in window) {
    (window as any).requestIdleCallback(() => initPaddle().catch(() => {}));
  } else {
    initPaddle().catch(() => {});
  }

  (async () => {
    // await restoreSession();

    // 初始化全局事件处理器
    // const userStore = useUserStore();
    // if (userStore.isLoggedIn) {
    //   globalEventHandler.init(userStore.user.user_id);
    // }

    app.use(router);
    app.use(i18n);
    app.use(directives);
    router.isReady().then(() => {
      app.mount("#app");
      loading.value = false;
    });
  })();

  // 监听 unauthorized 事件
  // window.addEventListener("unauthorized", (event: any) => {
  //   globalEventHandler.destroy();

  //   emitter.emit("user-logout");
  //   const { url } = event.detail;
  //   if (url) {
  //     set(authStorage.value, "loginState.redirectUrl", url);
  //     set(authStorage.value, "token", null);
  //   }
  //   router.push("/login");
  // });

  // // 页面卸载时清理资源
  // window.addEventListener("beforeunload", () => {
  //   globalEventHandler.destroy();
  // });
}
